module.exports = __webpack_public_path__ + "img/ZWF_Ignac_Magda.8bede7dd.jpg";